import {useState, useEffect} from 'react';
import {Box, Typography} from '@mui/material';
import AurButton from '../../../common/aur-button/AurButton';
import styles from './../../../common/aur-select-dropdown/style.module.scss';
import {ReactComponent as BackgroundImage} from '../../../../assests/svg/glow-right.svg';
import AurSvgIcon from '../../../common/aur-svg-icon/AurSvgIcon';
import {t} from 'i18next';
import {IAnalyzerConfig} from '../../model';
import {useAnalytics} from '../../../../hooks/useAnalytics';
import {
  GA_CLICK_TYPES,
  GA_EVENT_NAMES,
  GA_REGIONS,
  GA_SUBPAGE_TYPE,
} from '../../../../constants/analyticsConstants';

interface IanalyzersList {
  analyzersList: IAnalyzerConfig[];
  selectedAnalyzer: (analyzer: string) => void;
  activeAnalyzer: string;
}

const CustomIndexstep3LeftRail = (props: IanalyzersList) => {
  const {analyzersList, selectedAnalyzer, activeAnalyzer} = props;
  const {trackGAEvent} = useAnalytics();

  const SCROLL_BAR_STYLE_CLASS = 'aur-item-container-scroll';
  const itemContainerMaxHeight = 1116;
  const [activeItem, setActiveItem] = useState<string>(
    activeAnalyzer || analyzersList[0]?.name || ''
  );

  // Update activeItem when activeAnalyzer or analyzersList change
  useEffect(() => {
    if (activeAnalyzer) {
      setActiveItem(activeAnalyzer);
    } else if (analyzersList.length > 0) {
      setActiveItem(analyzersList[0].name);
    }
  }, [activeAnalyzer, analyzersList]);

  const selectAnalyzers = (analyzer: string) => {
    setActiveItem(analyzer);
    selectedAnalyzer(analyzer);
    trackGAEvent({
      eventName: GA_EVENT_NAMES.CLICK,
      click: {
        name: analyzer,
        type: GA_CLICK_TYPES.LINK,
        region: GA_REGIONS.LEFT_NAV_BAR,
        action: t('gaTracking.indexManagement.newIndexAnalyzerSettingViewed'),
      },
      subPage: {
        subpage_name: t('gaTracking.indexManagement.analyzerInformation'),
        subpage_type: GA_SUBPAGE_TYPE.TAB,
      },
    });
  };

  return (
    <div className="left-container">
      <div className="processing-exception-report-sidebar-content">
        <Box
          sx={{
            overflowX: 'hidden',
            overflowY: 'auto',
            maxHeight: `${itemContainerMaxHeight}px`,
          }}
          className={`${SCROLL_BAR_STYLE_CLASS} ${styles.aurItemContainerScrollbar} report-side-bar analyser-side-bar`}
        >
          {analyzersList.length !== 0 &&
            analyzersList.map((item: IAnalyzerConfig) =>
              item.isVisible ? (
                <AurButton
                  key={item.name}
                  dataTestId={item.name}
                  type="continue"
                  onClick={() => selectAnalyzers(item.label ?? '')}
                  disabled={activeItem === item.label}
                  classNames={`sidebar-btn ${activeItem === item.label ? 'active' : ''} ${item.label?.toLowerCase().includes(t('indexes.customIndex.step3.consiliocjk')) && 'button-cjk'}`}
                  ariaLabel={`${item.label} ${t('indexes.customIndex.step3.chinese')} ${t('indexes.customIndex.step3.japanese')} ${t('indexes.customIndex.step3.korean')}`}
                >
                  <Typography
                    className={`typo-text subhead2_size light-blue-text tab-label ${activeItem === item.label ? 'active-tab-btn' : ''}`}
                  >
                    {item.label && <>{item.label}</>}
                  </Typography>
                  {item.name
                    .toLowerCase()
                    .includes(t('indexes.customIndex.step3.consiliocjk')) && (
                    <div
                      className="analyzer-icons-container"
                      aria-hidden="true"
                    >
                      <div className="analyzer-icons">
                        <AurSvgIcon src="images/chinese_flag.svg" />
                        <Typography className="typo-text body4_size analyzer-change-description cjk-text">
                          {' '}
                          {t('indexes.customIndex.step3.chinese')}{' '}
                        </Typography>
                      </div>
                      <div className="analyzer-icons">
                        <AurSvgIcon src="images/japan_flag.svg" />
                        <Typography className="typo-text body4_size analyzer-change-description cjk-text">
                          {t('indexes.customIndex.step3.japanese')}{' '}
                        </Typography>
                      </div>
                      <div className="analyzer-icons">
                        <AurSvgIcon src="images/korean_flag.svg" />
                        <Typography className="typo-text body4_size analyzer-change-description cjk-text">
                          {t('indexes.customIndex.step3.korean')}{' '}
                        </Typography>
                      </div>
                    </div>
                  )}
                </AurButton>
              ) : (
                <></>
              )
            )}
        </Box>
      </div>
      <BackgroundImage
        className="background-image analyzer-sidebar-background"
        aria-hidden="true"
      />
    </div>
  );
};

export default CustomIndexstep3LeftRail;
